import React, {useState} from "react";
import ReactSelect, { components } from "react-select";
import { selectorOfRecipientsStyles } from "./SelectorOfRecipients.styled";
import arrowUp from "../../../../images/caret-up.svg";

export const defaultProp = {
    label: "Select all", value: "*"
};

export const SelectorOfRecipients = ({selectValues, multipleSelect = false, closeMenuOnSelect= true, callback}) => {
    const [selectList, setSelectList] = useState(selectValues || []);
    const [optionSelected, setOptionSelected] = useState([]);

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />
                    <span>{props.label}</span>
                </components.Option>
            </div>
        );
    }

    const MultiValue = (props) => (
        <components.MultiValue {...props}>
            <span>{props.data.label}</span>
        </components.MultiValue>
    );

    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <img alt="" src={arrowUp}/>
            </components.DropdownIndicator>
        );
    };

    const handleChange = (selected) => {
        if (selected[selected.length - 1]?.value === defaultProp.value){
            selected.pop();
            selected = selectList.length === selected.length ? [] : [...selectList];
        }

        setOptionSelected(selected);
        if (typeof callback === 'function') {
            callback(selected);
        }
    };

    return (
        <ReactSelect
            styles={selectorOfRecipientsStyles}
            isMulti={multipleSelect}
            options={multipleSelect ? [defaultProp, ...selectList] : selectList}
            closeMenuOnSelect={closeMenuOnSelect}
            hideSelectedOptions={false}
            components={{Option, MultiValue, DropdownIndicator}}
            onChange={handleChange}
            value={optionSelected}
            isClearable={false}
            isSearchable={false}
            // menuIsOpen={true}
        />
    );
}
